import { Button } from '@linktivity/link-ui';
import { useNavigate } from 'react-router-dom';
import styles from './not_found.module.css';

const NotFoundView: React.FC = ({}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.notFound}>
      <div className={styles.inner}>
        <h1 className={styles.title}>404</h1>
        <Button variant="outlined" onClick={() => navigate('/dashboard')}>
          Home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundView;
